<template>
  <div>
    <Table :data="reportData" :columns="columns"></Table>
    <Modal
      v-model="declareReportVisible"
      :title="declareReportTitle"
      width="98%"
      height="95%"
      class="declare-report"
      :transfer="flowPosition==='detail'"
    >
      <iframe
        :src="declareReportUrl"
        style="width:100%;height:98%;border:0"
      ></iframe>
      <div slot="footer"></div>
    </Modal>
    <Modal
      v-model="fillDetailVisible"
      :title="declareReportTitle"
      width="98%"
      :mask-closable="false"
      class="declare-report"
      :transfer="flowPosition==='detail'"
    >
      <div v-if="fillTableType==='rule'">
        <commissionRuleDetail
          :flowDetail="flowDetail"
          :readonly="true"
        ></commissionRuleDetail>
      </div>
      <div v-if="fillTableType==='task'">
        <commissionTaskDetail
          :flowDetail="flowDetail"
          :readonly="true"
        ></commissionTaskDetail>
      </div>
      <div slot="footer">
      </div>
    </Modal>
  </div>
</template>

<script>
import CommissionRuleDetail from './commissionDetail/commissionRuleDetail'
import CommissionTaskDetail from './commissionDetail/commissionTaskDetail'
import { formatDate } from '@/lib/tool'
import requestUrls from '@/lib/requestUrls'

export default {
  name: 'commissionDeclareExtra',
  components: {
    CommissionRuleDetail,
    CommissionTaskDetail
  },
  props: {
    flowDetail: {
      type: Object
    },
    flowPosition: {
      type: String,
      default: 'detail'
    },
    flowLine: {
      type: String,
      default: '线下'
    }
  },
  data() {
    return {
      declareReportTitle: '',
      declareReportUrl: '',
      declareReportVisible: false,
      fillDetailVisible: false,
      fillTableType: '',
      columns: [
        {
          title: '报表类型',
          width: 300,
          key: 'reportType'
        },
        {
          title: '报表数据',
          render: (h, params) => {
            let reportArr = []
            params.row.report.forEach(report => {
              reportArr.push(h('a', {
                domProps: {
                  href: 'javascript:void(0)'
                },
                style: {
                  marginRight: '20px',
                  display: 'inline-block'
                },
                on: {
                  click: () => {
                    this.viewReport(report.key)
                  }
                }
              }, report.title))
            })
            return h('div', reportArr)
          }
        }
      ],
      offlineData: [
        {
          reportType: '分公司当月一览表（仅供查阅）（线下）',
          report: [
            {
              title: '当月收入一览表',
              key: 'income'
            },
          ]
        },
        {
          reportType: '表1：计算提成收入一览表（线下）',
          report: [
            {
              title: '计算提成收入一览表',
              key: 'calculate'
            },
          ]
        },
        {
          reportType: '表2：对复核计算提成的收入进行分拆（线下）',
          report: [
            {
              title: '对复核计算提成的收入进行分拆',
              key: 'split'
            },
          ]
        },
        {
          reportType: '当月数据一览（线下）(2021年回款)',
          report: [
            {
              title: '奖金确认表',
              key: 'allot2021'
            },
            {
              title: '业务奖金明细表',
              key: 'bussinessDetail2021'
            },
            {
              title: '项目奖金明细表',
              key: 'projectDetail2021'
            },
            {
              title: '分公司当月可分配奖金总额表',
              key: 'distribute2021'
            },
          ]
        },
        {
          reportType: '当月数据一览（线下）(2020年回款)',
          report: [
            {
              title: '奖金确认表',
              key: 'allotN'
            },
            {
              title: '业务奖金明细表',
              key: 'bussinessDetailN'
            },
            {
              title: '项目奖金明细表',
              key: 'projectDetailN'
            },
            {
              title: '分公司当月可分配奖金总额表',
              key: 'distributeN'
            },
          ]
        },
        {
          reportType: '当月数据一览（线下）(2019年回款)',
          report: [
            {
              title: '奖金确认表',
              key: 'allot'
            },
            {
              title: '业务奖金明细表',
              key: 'bussinessDetail'
            },
            {
              title: '项目奖金明细表',
              key: 'projectDetail'
            },
            {
              title: '分公司当月可分配奖金总额表',
              key: 'distribute'
            },
          ]
        },
        // {
        //   reportType: '奖金发放规则（仅供查阅）（线下）',
        //   report: [
        //     {
        //       title: '分公司奖金规则申报表',
        //       key: 'rule'
        //     },
        //     {
        //       title: '分公司奖金剩余部分分配规则申报表',
        //       key: 'restRule'
        //     },
        //     {
        //       title: '业务员月度任务申报表',
        //       key: 'task'
        //     },
        //   ]
        // },
      ],
      onlineData: [
        {
          reportType: '线上提成报表（线上）',
          report: [
            {
              title: '分公司确认',
              key: 'onlineConfirm'
            },
            {
              title: '客户经理收入（仅供查阅）',
              key: 'onlineIncome'
            },
            {
              title: '收入明细表（仅供查阅）',
              key: 'onlineDetail'
            },
          ]
        },
      ]
    }
  },
  computed: {
    reportData() {
      if (this.flowLine.indexOf('线上线下')!==-1) {
        // this.offlineData.unshift(4, 0); 
        // Array.prototype.splice.apply(this.onlineData, this.offlineData); 
        // return this.onlineData
        return this.offlineData.concat(this.onlineData)
      }
      if (this.flowLine.indexOf('线下')!==-1) {
        return this.offlineData
      }
      if (this.flowLine.indexOf('线上')!==-1) {
        return this.onlineData
      }
    }
  },
  methods: {
    viewReport(type) {
      if (this.flowDetail.area === '' || this.flowDetail.company === '' || this.flowDetail.time === '') {
        this.$Message.info('请确认时间、地区及分子公司')
        return
      }

      // 报表特殊时间要求传入
      let baseTime = formatDate(this.flowDetail.time)
      let time = baseTime.split(' ')[0].substr(0, 8) + '01'
      let startTime = baseTime.split(' ')[0].substr(0, 4) + '-01-01'
      let endTime = baseTime.split(' ')[0].substr(0, 4) + '-12-01'

      if (type === 'rule') {
        this.declareReportTitle = '分公司奖金规则申报表'
        this.fillTableType = 'rule'
        this.fillDetailVisible = true
        return
      }
      if (type === 'restRule') {
        this.declareReportTitle = '分公司奖金剩余部分分配规则申报表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B63d0%5D%5B6210%5D%5B89c4%5D%5B5219%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B5269%5D%5B4f59%5D%5B90e8%5D%5B5206%5D%5B5206%5D%5B914d%5D%5B89c4%5D%5B5219%5D.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&starttime=${startTime}&starttime=${startTime}`
      }
      if (type === 'task') {
        this.declareReportTitle = '业务员月度任务申报表'
        this.fillTableType = 'task'
        this.fillDetailVisible = true
        return
      }
      if (type === 'income') {
        this.declareReportTitle = '当月收入一览表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成2.0/分公司收入确认/分公司当月收入明细.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'calculate') {
        this.declareReportTitle = '计算提成收入一览表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成3.0/分公司收入确认/分公司财务助理收入确认.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}&username=${this.$store.state.session.user.name}`
      }
      if (type === 'split') {
        this.declareReportTitle = '提成收入分拆表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成3.0/分公司收入确认/提成拆分表.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'allot') {
        this.declareReportTitle = '奖金确认表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B63d0%5D%5B6210%5D%5B6c47%5D%5B603b%5D%2F%5B5956%5D%5B91d1%5D%5B786e%5D%5B8ba4%5D%5B8868%5D.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'bussinessDetail') {
        this.declareReportTitle = '业务奖金明细表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B63d0%5D%5B6210%5D%5B6c47%5D%5B603b%5D%2F%5B4e1a%5D%5B52a1%5D%5B5956%5D%5B91d1%5D%5B660e%5D%5B7ec6%5D%5B8868%5D%5B4e00%5D.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'projectDetail') {
        this.declareReportTitle = '项目奖金明细表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B63d0%5D%5B6210%5D%5B6c47%5D%5B603b%5D%2F%5B9879%5D%5B76ee%5D%5B5956%5D%5B91d1%5D%5B660e%5D%5B7ec6%5D%5B8868%5D%5B4e8c%5D.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'distribute') {
        this.declareReportTitle = '分公司当月可分配奖金总额表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B63d0%5D%5B6210%5D%5B6c47%5D%5B603b%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B5f53%5D%5B6708%5D%5B53ef%5D%5B5206%5D%5B914d%5D%5B5956%5D%5B91d1%5D%5B603b%5D%5B989d%5D%5B8868%5D%5B4e09%5D.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'allot2021') {
        this.declareReportTitle = '奖金确认表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成3.0/分公司提成汇总/奖金确认表.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'bussinessDetail2021') {
        this.declareReportTitle = '业务奖金明细表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成3.0/分公司提成汇总/业务奖金明细表一.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'projectDetail2021') {
        this.declareReportTitle = '项目奖金明细表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成3.0/分公司提成汇总/项目奖金明细表二.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'distribute2021') {
        this.declareReportTitle = '分公司当月可分配奖金总额表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成3.0/分公司提成汇总/分公司当月可分配奖金总额表三.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'allotN') {
        this.declareReportTitle = '奖金确认表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成2.0/分公司提成汇总/奖金确认表.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'bussinessDetailN') {
        this.declareReportTitle = '业务奖金明细表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成2.0/分公司提成汇总/业务奖金明细表一.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'projectDetailN') {
        this.declareReportTitle = '项目奖金明细表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成2.0/分公司提成汇总/项目奖金明细表二.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'distributeN') {
        this.declareReportTitle = '分公司当月可分配奖金总额表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/财务提成2.0/分公司提成汇总/分公司当月可分配奖金总额表三.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'onlineConfirm') {
        this.declareReportTitle = '分公司确认'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B7ebf%5D%5B4e0a%5D%5B6536%5D%5B5165%5D%5B786e%5D%5B8ba4%5D%2F%5B7ebf%5D%5B4e0a%5D%5B6536%5D%5B5165%5D%5B786e%5D%5B8ba4%5D.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'onlineIncome') {
        this.declareReportTitle = '客户经理收入'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B7ebf%5D%5B4e0a%5D%5B6536%5D%5B5165%5D%5B786e%5D%5B8ba4%5D%2FCwProjectView%28%5B5ba2%5D%5B6237%5D%5B7ecf%5D%5B7406%5D%5B5206%5D%5B7ec4%5D%29.cpt&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      if (type === 'onlineDetail') {
        this.declareReportTitle = '收入明细表'
        this.declareReportUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B7ebf%5D%5B4e0a%5D%5B6536%5D%5B5165%5D%5B786e%5D%5B8ba4%5D%2FCwProjectView.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&collectiondate=${time}`
      }
      this.declareReportVisible = true
    },
  }
}
</script>

<style lang="less">
.declare-report {
  .ivu-modal {
    top: 20px;
    height: 95%;
    .ivu-modal-content {
      height: 100%;
    }
    .ivu-modal-body {
      height: 90%;
      overflow: auto;
    }
    .ivu-icon-ios-close-empty {
      font-size: 45px;
      color: #000;
    }
  }
}
</style>
